import React from "react";

import UserCard from "./UserCard";
import imgProfile from "../Assets/profile.png";
import logo from "../Assets/logo.png";
import { timeAgo } from "../Utils/timeFormat";

function RecentUsers({ userInfoList, loadUserPlayList, onSelectUser }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3 md:gap-4">
      {userInfoList.map((list) => (
        <UserCard
          username={list.username}
          key={list.username}
          online={list.online}
          subtitle={
            list.online ? `▶ ${list.song}` : `${timeAgo(list.seenSince)} ago`
          }
          image={list.public ? list.image : logo}
          onSelect={() => {
            loadUserPlayList(list.id);
          }}
          action={
            <button
              className="p-2 hover:bg-black hover:bg-opacity-20 hover:bg-opacity-20 rounded-full transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                onSelectUser(list.username);
              }}
              aria-label="View profile"
            >
              <img
                className="w-5 h-5 brightness-0 invert"
                src={imgProfile}
                alt=""
              />
            </button>
          }
        />
      ))}
    </div>
  );
}

export default RecentUsers;
